import EmailModal from './EmailModal';

export default {
	Modal: EmailModal
};
